import { loadCss, loadModules } from 'esri-loader';
import * as Constants from "./constants";

export const initMap = () => {
  console.log("map.initMap");
  loadCss('https://js.arcgis.com/4.11/esri/css/main.css');
  return loadModules([
    "esri/Map",
    "esri/views/MapView",
    "esri/layers/MapImageLayer",
    "esri/layers/TileLayer",
    "esri/layers/WMSLayer",
    "esri/geometry/Point",
    "esri/geometry/Extent",
    "esri/Graphic",
    "esri/tasks/IdentifyTask",
    "esri/tasks/support/IdentifyParameters",
    "esri/tasks/FindTask",
    "esri/tasks/support/FindParameters",
    "esri/tasks/Locator",
    "esri/tasks/PrintTask",
    "esri/tasks/support/PrintTemplate",
    "esri/tasks/support/PrintParameters",
    "esri/geometry/SpatialReference"
  ], {
      url: 'https://js.arcgis.com/4.11/'
    })
    .then(([
      Map,
      MapView,
      MapImageLayer,
      TileLayer,
      WMSLayer,
      Point,
      Extent,
      Graphic,
      IdentifyTask,
      IdentifyParameters,
      FindTask,
      FindParameters,
      Locator,
      PrintTask, PrintTemplate, PrintParameters,
      SpatialReference
    ]) => {
      let map = new Map();

      let grayLayer = new TileLayer({
        url: Constants.grayBasemapUrl
      });
      map.add(grayLayer);

      // let imageLayer = new TileLayer({
      //   url: Constants.imageUrl
      // });
      // map.add(imageLayer);
      let nearMapLayer = new WMSLayer({
        id: "nearMapLayer",
        title: "Latest NearMap Imagery",
        url: Constants.nearMAPURL,
        sublayers: [{
          name: "area/1459a757-8a92-4773-aada-4ad9090114a6/all/all-combined",
          title: "Latest NearMap Imagery",
          visible: true
        }]
      });
      map.add(nearMapLayer);

      let basemapLayer = new TileLayer({
        url: Constants.basemapUrl
      });
      map.add(basemapLayer);

      let zoningLayer = new TileLayer({
        id: "ezoningLayer",
        url: Constants.zoningUrl,
        opacity: 0.5
      });
      map.add(zoningLayer);

      let parcelLayer = new MapImageLayer({
        url: Constants.parcelUrl,
        visible: false
      });
      map.add(parcelLayer);

      let egDataLayer = new MapImageLayer({
        url: Constants.egDataUrl,
        visible: false
      });
      map.add(egDataLayer);

      let view = new MapView({
        container: "main-right",
        map: map,
        center: [-117.263, 33.049],
        zoom: 13,
        constraints: {
          minZoom: 13,
          maxZoom: 20
        }
      });
      zoningLayer.when(function () {
        let ext = zoningLayer.fullExtent.clone();
        view.goTo(ext.expand(.65));
      });

      return ({
        mapView: view,
        Point: Point,
        Extent: Extent,
        Graphic: Graphic,
        IdentifyTask: IdentifyTask,
        IdentifyParameters: IdentifyParameters,
        FindTask: FindTask,
        FindParameters: FindParameters,
        Locator: Locator,
        PrintTask: PrintTask, PrintTemplate: PrintTemplate, PrintParameters: PrintParameters,
        SpatialReference: SpatialReference
      });
  });
};
